import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../../theme/Component/hooks/useModal';
import { _PharmaRecordState } from '../../../../../core/services/dataBean/EntityCatalogVdos';
import { BasicTable, MASK_NUMBER } from '../../../../theme/Component/BasicTable';
import { Modal } from '../../../../theme/Component/Modal';
import usePaginator from '../../../../theme/Component/usePaginator';
import { BasicButton } from '../../../../theme/Component/BasicButton';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const PharmaStateEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_PharmaRecordState)
    const [id, setID] = useState(null);
const paginador = usePaginator();
const [regexStr, setregexStr] = useState<any>(null)
    const modal = useModal("Estado Registro Médico", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

   useEffect(() => {
        getLista();
    }, [paginador.page])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDPharmaRecordState  == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };



    const getLista = () => {

        instance.getPharmaRecordStateCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
   const head = [
        { title: 'ID', property: 'IDPharmaRecordState', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Estado Registro Médico"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                     <div className="col-md-6">
                                        <label>Búsqueda por Texto</label>
                                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                                    </div>
                                    <div className="col-md-6 mt-4 p-2">
                                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDPharmaRecordState); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}